import { useStaticData } from '@mc/static-data-react'
import { STEPS, useCheckoutMachine } from '../../lib'

export const useNavigationSteps = () => {
  const ctx = useCheckoutMachine()
  const { isGift } = useStaticData<{ isGift: boolean }>()

  const { context } = ctx
  if (!context) {
    return {
      context: {
        currentStep: 1,
        hideNavbarElements: null,
        theme: null,
        isGift,
      },
      state: { value: STEPS.MEMBERSHIP },
    }
  }

  return ctx
}
